"use client";

import Context from "@/context/Context";
import Layout from "@/components/Header/Layout";
import Signin from "@/components/User/Signin";
import HomeChatSwitcher from "@/components/Common/HomeChatSwitcher";

const SigninClient = () => (
  <Context>
    <Layout />
    <Signin />
    <HomeChatSwitcher />
  </Context>
);

export default SigninClient;
